import { IHoleResult } from '../../../../../../../store/admin/holeResults/store';
import { TIFormatPrefix } from '../../../../../../../store/admin/roundFormats/store';
import { IMetaResult } from '../../../../../../../store/admin/roundResults/store';

import { getResultFieldName } from '../../../ResultsTable/Utils/getResultFieldName';

export type IGetCTPHoleWinner = (
  holeResults: IHoleResult[],
  considerFlights: boolean,
  adjustedHandicap: boolean
) => IHoleResult | undefined;

export const getCTPHoleWinner: IGetCTPHoleWinner = (
  holeResults,
  considerFlights,
  adjustedHandicap
) => {
  const processedPrefix = `ctp${considerFlights ? 'Flight' : 'Round'}` as TIFormatPrefix;

  const winnerFieldName = getResultFieldName(
    processedPrefix,
    null,
    'Winner',
    adjustedHandicap
  ) as keyof IMetaResult;

  return holeResults.find((result: IHoleResult) => result[winnerFieldName] && result.pinDistance);
};
